import { render } from "./SheetSongBaseForm.vue?vue&type=template&id=3bf32d0a&scoped=true"
import script from "./SheetSongBaseForm.vue?vue&type=script&lang=ts"
export * from "./SheetSongBaseForm.vue?vue&type=script&lang=ts"

import "./SheetSongBaseForm.vue?vue&type=style&index=0&id=3bf32d0a&lang=css"
import "./SheetSongBaseForm.vue?vue&type=style&index=1&id=3bf32d0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3bf32d0a"

export default script